import type { LabFeatureFlags } from 'constants/lab'
import { useAppSelector } from 'hooks/reduxHooks'

export const useLabFeatureFlag = (flag: LabFeatureFlags): App.LabFeatureFlagResult | undefined => {
  const featureFlag = useAppSelector(state => state.system.features.labFlags[flag])
  return featureFlag
}
